import styles from "./UserInfoItem.module.css";
import Button from "../common/Button";
import { MouseEvent } from "react";

interface UserInfoItemProps {
    id: string;
    value: string;
    label?: string;
    labelDesc?: string;
    button?: string;
    vertical?: boolean;
    buttonOnClick?: (e: MouseEvent<HTMLElement>) => void;
}
/**
 * @author bakim
 * @date 2024-09-11 10:56:38
 * @remark 사용자 정보
 * @param {string} id (required) 아이디
 * @param {string} value  (required) 내용
 * @param {string} label 라벨 정보
 * @param {string} labelDesc 라벨 하단 설명
 * @param {string} button 버튼 명
 * @param {boolean} vertical vertical 정렬 여부
 * @param {(e: MouseEvent<HTMLElement>) => void} buttonOnClick 버튼 클릭 시 콜백 함수
 * @returns UserInfoItem
 */
const UserInfoItem = (props: UserInfoItemProps) => {
    const handleButtonClick = (e: MouseEvent<HTMLElement>) => {
        props.buttonOnClick && props.buttonOnClick(e);
    };
    return (
        <div className={styles.row}>
            <div className={styles.label}>
                {props.label && props.label}
                {props.labelDesc && <span>{props.labelDesc}</span>}
            </div>
            <div id={props.id} className={`${styles.value}`}>
                {props.value}
                {props.button && <Button label={props.button} size="small" onClick={handleButtonClick} />}
            </div>
        </div>
    );
};

export default UserInfoItem;
